
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { resolveCategory } from '~/utils/category'
import { categoriesIconsMappings } from '~/constants/category/icon'
import { solidKeyFeaturesIcons } from '~/constants/classified/key-feature/icon/solid'
import { regularKeyFeaturesIcons } from '~/constants/classified/key-feature/icon/regular'
import KeyFeatureIcon from '~/components/car/classifieds/view/partials/key-features/KeyFeatureIcon.vue'
import { plotCategoryKeyFeaturesIcons } from '~/constants/classified/key-feature/icon/plot'
import { conditionKeyFeaturesIcons } from '~/constants/classified/key-feature/icon/condition'
import { defaultIconCategoryTags } from '~/constants/classified/key-feature/icon/default'
import { solidFallbackIcon } from '~/constants/classified/key-feature/icon'
import { categoryKeyFeaturesIcons } from '~/constants/classified/key-feature/icon/category'

export default Vue.extend({
  components: { KeyFeatureIcon },
  props: {
    keyFeatures: {
      type: Array,
      required: true
    },
    cols: {
      type: Number,
      default: 4
    },
    sm: {
      type: Number,
      default: 4
    },
    md: {
      type: Number,
      default: 4
    },
    lg: {
      type: Number,
      default: 3
    },

    noLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isPlotClassified: 'classifieds/view/isPlotClassified',
      isVehicleClassified: 'classifieds/view/isVehicleClassified'
    })
  },
  methods: {
    getIcon(feature) {
      // Specific handling for the category and condition key
      if (feature.key === 'category') {
        return this.getCategoryIcon(feature.extra)
      } else if (feature.key === 'condition') {
        return this.getConditionIcon(feature.extra.name)
      } else {
        return this.getGenericIcon(feature.key)
      }
    },
    getConditionIcon(name) {
      return conditionKeyFeaturesIcons[name]
    },
    getGenericIcon(key) {
      if (Object.keys(regularKeyFeaturesIcons).includes(key)) {
        return regularKeyFeaturesIcons[key]
      }
      return solidKeyFeaturesIcons[key] || solidFallbackIcon
    },
    normalizeValue(value: string) {
      if (value && value.match(/\S\/\S/gi)) {
        return value.replace(/\//g, ' / ')
      }
      return value
    },
    getCategoryIcon(extra) {
      const categoryIds = extra.category_ids || extra?.categoryIds
      const categoryTags = extra.category_tags || extra.categoryTags
      if (this.isVehicleClassified && categoryIds) {
        const icon = {
          icon: resolveCategory(categoriesIconsMappings, categoryIds),
          classes: 'vehicle-icon'
        }
        return icon
      } else {
        for (const tag of categoryTags) {
          let icon = null

          if (defaultIconCategoryTags.includes(tag)) {
            return categoryKeyFeaturesIcons.classifieds
          }

          if (this.isPlotClassified) {
            icon = plotCategoryKeyFeaturesIcons[tag]
          } else {
            icon = categoryKeyFeaturesIcons[tag]
          }
          if (icon) {
            return icon
          }
        }
      }
    }
  }
})
